(function($){
    $('.show-expiry-form').on('click', function(){
        $(this).closest('td').find('.set-reservation-expiration').slideToggle(500);
    })

    $('.remove-reservation').on('click', function(e){
        e.preventDefault();
        var rid = $(this).attr('data-id');
        bootbox.confirm({
            message: 'Czy na pewno chcesz usunąć rezerwację?',
            buttons: {
                confirm: {
                    label: 'Tak',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'Nie',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result === true) {
                    $.ajax({
                        url: ajax_ajax_obj.ajaxurl,
                        method: 'post',
                        data: {
                            'action': 'remove_reservation',
                            'rid': rid,
                            'nonce': ajax_ajax_obj.nonce
                        },
                        beforeSend: function (data) {

                        },
                        success: function (data) {
                            bootbox.alert('Rezerwacja usunięta', function () {
                                window.location.reload();
                            });
                        },
                        error: function (errorThrown) {
                            console.log(errorThrown);
                        }
                    });
                    console.log('ok')
                }
            }
        });
    })
})(jQuery)